// src/utils/iconMap.ts
import {
  Sparkles,
  Search,
  LayoutGrid,
  Rocket,
  Brain,
  BarChart,
  Folder
  // Add more icons here
} from 'lucide-react';

export const iconMap = {
  Sparkles,
  Search,
  LayoutGrid,
  Rocket,
  Brain,
  BarChart,
  Folder
  // Keep in sync with menuData icons
};

export type IconName = keyof typeof iconMap;
